import React from 'react';
import {Link} from 'react-router-dom'

const NotFound = () => {
    return (
        <div className='container py-5'>
            <div className="row">
                <div className="col-md-6 offset-md-3">
                <img src="error.png" className='img-fluid w-100' alt="" />
                <h1 className='fs-1 fw-bolder'>OooPs! Page Not Found</h1>
                <p>Oops! The page you are looking for does not exist. It might have been moved or deleted.</p>
                <Link to="/"><button className="btn bg-dark text-white fw-bolder px-4 py-2">Go to Home</button></Link>
                </div>
            </div>
        </div>
    );
};

export default NotFound;